<template>
  <div class="content posire">
    <div class="chart-title" v-if="chartTitle">{{chartTitle}}</div>
    <qx-bar-chart ref="barChart" :chartObj="totalData" height="260px" :width="width" />
  </div>
</template>

<script>
export default {
  props: {
    totalData: {
      type: Object,
      default: () => ({}),
    },
    width: {
      type: String,
      default: '100%',
    },
    chartTitle: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
    };
  },
  methods: {
    setOptions (data) {
      this.$refs.barChart.setOptions(data);
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  box-sizing: border-box;
  top: 0px;
}
.chart-title {
  font-size: 20px;
  text-align: center;
}
</style>
